function formatTwoDigit(digit) {
  return digit < 10 ? ("0" + digit).slice(-2) : digit;
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.toShortDateString = function () {
  var date = new Date(this.valueOf());

  var month_names = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  var day = date.getDate();
  var month_index = date.getMonth();
  var year = date.getFullYear();

  return (
    day.toString().lpad("0", 2) +
    " " +
    month_names[month_index] +
    " " +
    year.toString()
  );
};

Date.prototype.toShortMonthString = function () {
  var date = new Date(this.valueOf());

  var month_names = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  var month_index = date.getMonth();
  var year = date.getFullYear();

  return month_names[month_index] + " " + year.toString();
};

Date.prototype.toUTCDateTimeString = function () {
  var date = new Date(this.valueOf());

  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  var hrs = formatTwoDigit(date.getHours());
  var mins = formatTwoDigit(date.getMinutes());
  var secs = formatTwoDigit(date.getSeconds());

  return `${year}-${month}-${day}T${hrs.toString()}:${mins.toString()}:${secs.toString()}Z`;
};

Date.prototype.toUTCShortTimeString = function () {
  var date = new Date(this.valueOf());

  var hrs = date.getHours();
  var mins = formatTwoDigit(date.getMinutes());
  var secs = formatTwoDigit(date.getSeconds());
  var amOrPm = hrs >= 12 ? "PM" : "AM";

  return `${hrs.toString()}:${mins.toString()}:${secs.toString()} ${amOrPm}`;
};

Date.prototype.toSaveDate = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  // eslint-disable-next-line no-console
  // this.$logger.debug("save date",date)

  // eslint-disable-next-line no-console
  // this.$logger.debug("save data",year,month,day)

  return `${year}-${month}-${day}T00:00:00.000Z`;
};

Date.prototype.toSaveDateTime = function () {
  // get local values (no timezone adjustment)
  var year = this.getFullYear();
  var month = String(this.getMonth() + 1).padStart(2, "0");
  var day = String(this.getDate()).padStart(2, "0");
  var hours = String(this.getHours()).padStart(2, "0");
  var minutes = String(this.getMinutes()).padStart(2, "0");
  var seconds = String(this.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

Date.prototype.toFilterDateString = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  // eslint-disable-next-line no-console
  // this.$logger.debug("save date",date)

  // eslint-disable-next-line no-console
  // this.$logger.debug("save data",year,month,day)

  return `${year}-${month}-${day}T00:00:00Z`;
};

Date.prototype.toFilterDateStringFormattedReport = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  return `${year}-${month}-${day}T00:00:00`;
};

Date.prototype.toShortTimeString = function () {
  var date = new Date(this.valueOf());

  var hrs = date.getHours();
  var mins = formatTwoDigit(date.getMinutes());
  var secs = formatTwoDigit(date.getSeconds());
  var amOrPm = hrs >= 12 ? "PM" : "AM";

  if (hrs == 0) {
    hrs = 12;
  }

  if (hrs > 12) {
    hrs = hrs - 12;
  }

  if (hrs < 10) {
    hrs = "0" + hrs;
  }

  return `${hrs.toString()}:${mins.toString()}:${secs.toString()} ${amOrPm}`;
};

Date.prototype.toYYYYMMDD = function () {
  var month = "" + (this.getMonth() + 1),
    day = "" + this.getDate(),
    year = this.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

Date.prototype.toFriendlyDayString = function () {
  var date = new Date(this);
  var day_names = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return day_names[date.getDay()];
};

Date.prototype.toFriendlyDateTimeString = function () {
  return this.toShortDateString() + ", " + this.toShortTimeString();
};

Date.prototype.toFriendlyDBDateTimeString = function () {
  let utcTime = this.toUTCString().split(" ")[4];
  let utcYear = this.toUTCString().split(" ")[3];
  let utcMonth = this.toUTCString().split(" ")[2];
  let utcDay = this.toUTCString().split(" ")[1];
  var amOrPm = utcTime.split(":")[0] >= 12 ? "PM" : "AM";

  return `${utcDay} ${utcMonth} ${utcYear}, ${utcTime} ${amOrPm}`;
};

Date.prototype.removeTime = function () {
  var date = new Date(this);
  date.setHours(0, 0, 0, 0);
  return date;
};

Date.prototype.addGMTHours = function (h, m) {
  var copiedDate = new Date(this.getTime());

  if (h) copiedDate.setHours(copiedDate.getHours() + h);
  copiedDate.setMinutes(copiedDate.getMinutes() + m);

  return copiedDate;
};

Date.prototype.getStartDateWithUTC = function () {
  let utcTime = this.toUTCString().split(" ")[4];
  let utcYear = this.toUTCString().split(" ")[3];
  // let utcMonth = this.toUTCString().split(" ")[2];
  let utcDay = this.toUTCString().split(" ")[1];

  var month = formatTwoDigit(new Date(this.toUTCString()).getMonth() + 1);

  return `${utcYear}-${month}-${utcDay}T${utcTime}Z`;
};

Date.prototype.localStarDateTimeInUTC = function () {
  return new Date(
    this.getFullYear(),
    this.getMonth(),
    this.getDate(),
    0, // hours
    this.getTimezoneOffset(), // subtract timezone offset in minutes
    0, // seconds
    0 // milliseconds
  );
};

Date.prototype.localEndDateTimeInUTC = function () {
  let date = new Date(
    this.getFullYear(),
    this.getMonth(),
    this.getDate(),
    23, // hours
    59 + this.getTimezoneOffset(), // subtract timezone offset in minutes
    59, // seconds
    0 // milliseconds
  );

  date.addDays(1);
  date.setSeconds(date.getSeconds() - 1);

  return date;
};

Date.prototype.toFilterDateStartTime = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  return new Date(`${year}-${month}-${day}T00:00:00`);
};

Date.prototype.toFilterDateEndTime = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  return new Date(`${year}-${month}-${day}T23:59:59`);
};

Date.prototype.dateWithOffset = function () {
  return new Date(
    new Date(this).setMinutes(
      new Date(this).getMinutes() - new Date(this).getTimezoneOffset()
    )
  );
};

Date.prototype.toSaveDateObject = function () {
  return new Date(new Date(this).toSaveDate());
};

Date.prototype.toTimeString = function () {
  var date = new Date(this.valueOf());

  var hrs = date.getHours();
  var mins = formatTwoDigit(date.getMinutes());

  if (hrs == 0) {
    hrs = 12;
  }

  if (hrs < 10) {
    hrs = "0" + hrs;
  }

  return `${hrs.toString()}:${mins.toString()}`;
};

Date.prototype.toSaveDateEndTime = function () {
  var date = new Date(this.valueOf());
  var year = date.getFullYear();
  var month = formatTwoDigit(date.getMonth() + 1);
  var day = formatTwoDigit(date.getDate());

  return `${year}-${month}-${day}T23:59:59`;
};

Date.prototype.getEndOfWeekDate = function () {
  // Create a new date object from the input
  var newDate = new Date(this);

  // Get the current day of the week (0-6, Sunday is 0)
  var day = newDate.getDay();

  // Calculate the number of days till the next Sunday
  var daysTillEndOfWeek = 0 === day ? 0 : 7 - day;

  // Set the date to that day
  newDate.setDate(newDate.getDate() + daysTillEndOfWeek);

  // Set the time to the end of the day
  // newDate.setHours(23, 59, 59, 999);

  return newDate;
};

Date.prototype.toYMD = function () {
  const date = new Date(this.valueOf());

  if (isNaN(date)) return null; // invalid date → handle safely

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const DateFromIsoWithoutZ = (isoString) => {
  return new Date(isoString.replace("Z", ""));
};
